import { HttpClient } from '@adapters/HttpClient';

export interface OrdersStatsResponse {
  delivery: number;
  transit: number;
  returns: number;
  other_states: number;
}

export interface OrdersStats {
  delivered: number;
  inTransit: number;
  returns: number;
  other: number;
}

export interface OrdersStatsQueryParams {
  'date[start]'?: string;
  'date[end]'?: string;
  shop_ids?: string;
  payment_method_ids?: string;
  product_ids?: string;
  pack_ids?: string;
  search?: string;
}

export class StatsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Obtiene las estadísticas de pedidos enviados desde la API
   * @returns Promise<OrdersStats> - Estadísticas de pedidos enviados
   */
  async getOrdersStats(params?: OrdersStatsQueryParams): Promise<OrdersStats> {
    try {
      const response = await this.httpClient.get<OrdersStatsResponse>('/report/orders-sent', params);

      // Mapear la respuesta de la API al formato esperado por el componente
      const mappedStats = {
        delivered: response.delivery,
        inTransit: response.transit,
        returns: response.returns,
        other: response.other_states,
      };

      return mappedStats;
    } catch (error: any) {
      console.log('🔍 StatsApiAdapter - Error:', {
        message: error.message,
        response: error.response,
      });

      // En caso de error, retornar valores por defecto
      return {
        delivered: 0,
        inTransit: 0,
        returns: 0,
        other: 0,
      };
    }
  }
}
